import { render, staticRenderFns } from "./WxAuthentication.vue?vue&type=template&id=04d87e82&scoped=true&"
import script from "./WxAuthentication.vue?vue&type=script&lang=js&"
export * from "./WxAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./WxAuthentication.vue?vue&type=style&index=0&id=04d87e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d87e82",
  null
  
)

export default component.exports